import type { OrderLineUpload } from '@/types/order-wizard';

export function OptionUploadCards({ uploads }: { uploads?: OrderLineUpload[] }) {
  if (!uploads || uploads.length === 0) return null;
  return (
    <div className="mt-3 flex flex-col gap-2">
      {uploads.map((file) => (
        <div
          key={`${file.fileName}:${file.sizeBytes ?? 0}:${file.widthPx ?? 0}`}
          className="flex items-center gap-3 rounded-lg border border-border bg-white px-3 py-2"
        >
          {file.thumbUrl ? (
            <img
              src={file.thumbUrl}
              alt=""
              className="h-16 w-16 rounded border border-border object-contain bg-[repeating-conic-gradient(#f3f4f6_0%_25%,#fff_0%_50%)] [background-size:12px_12px]"
            />
          ) : (
            <div className="flex h-12 w-12 items-center justify-center rounded border border-border bg-surface-tertiary text-[10px] font-semibold uppercase text-text-tertiary">
              File
            </div>
          )}
          <div className="min-w-0">
            <p className="truncate text-sm font-medium text-text-primary">{file.fileName}</p>
            <p className="text-xs text-text-tertiary">
              {[file.mimeType, formatBytes(file.sizeBytes), formatPixels(file)].filter(Boolean).join(' · ')}
            </p>
            {file.thumbUrl ? (
              <a
                href={file.thumbUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs font-medium text-brand-600 hover:underline"
              >
                Preview
              </a>
            ) : null}
          </div>
        </div>
      ))}
    </div>
  );
}

function formatBytes(size: number | null): string | null {
  if (size == null) return null;
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
  return `${(size / (1024 * 1024)).toFixed(1)} MB`;
}

function formatPixels(file: OrderLineUpload): string | null {
  if (file.widthPx == null || file.heightPx == null) return null;
  return `${Math.round(file.widthPx)}×${Math.round(file.heightPx)}`;
}
